export default __webpack_public_path__ + "static/media/Gauntlets of the Wicked.933c947b.jpg";